import { useState, useEffect } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import loginService from 'src/services/loginService';

export default function LoginByAccessCode(props) {
  const [t] = useTranslation('common');
  const { open, cancel, send } = props;
  const [accessCode, setAccessCode] = useState('');
  const [accessCodeValidation, setAccessCodeValidation] = useState({
    errorState: false,
    errorText: ''
  });
  LoginByAccessCode.propTypes = {
    open: PropTypes.bool.isRequired,
    cancel: PropTypes.bool.isRequired,
    send: PropTypes.func.isRequired
  };

  const handleChange = (event) => {
    setAccessCode(event.target.value);
  };

  const loginByAccessCode = async () => {
    const response = await loginService.loginByAccessCode(accessCode);
    if (response.responseCode !== null) {
      setAccessCodeValidation({ error: true, errorText: t('FORMS.wrongAccessCode') });
    } else {
      setAccessCodeValidation({ error: false, errorText: '' });
      send(response);
    }
  };

  useEffect(() => {
    setAccessCodeValidation({ error: false, errorText: '' });
  }, [open]);

  return (
    <div>
      <Dialog open={open} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {t('FORMS.loginByAccessCode')}
        </DialogTitle>
        <DialogContent>
          <TextField
            error={accessCodeValidation.error}
            helperText={accessCodeValidation.errorText}
            onChange={handleChange}
            onBlur={handleChange}
            margin="dense"
            id="accessCode"
            label={t('FORMS.accessCode')}
            name="accessCode"
            type="password"
            fullWidth
            size="medium"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { cancel(); setAccessCode(''); }} color="primary">
            {t('BUTTONS.cancel')}
          </Button>
          <Button onClick={() => { loginByAccessCode(); }} color="primary" disabled={accessCode === ''}>
            {t('BUTTONS.login')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
